var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIconGray = function SvgCloseIconGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 5.586 4.95-4.95 1.415 1.414L8.415 7l4.95 4.95-1.414 1.414L7 8.414l-4.95 4.95L.637 11.95 5.587 7 .637 2.05 2.05.636 7 5.586Z",
    fill: "#727292"
  })));
};
export { SvgCloseIconGray as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMDAwNzIgNS41ODZMMTEuOTUwNyAwLjYzNjAwMkwxMy4zNjQ3IDIuMDVMOC40MTQ3MiA3TDEzLjM2NDcgMTEuOTVMMTEuOTUwNyAxMy4zNjRMNy4wMDA3MiA4LjQxNEwyLjA1MDcyIDEzLjM2NEwwLjYzNjcxOSAxMS45NUw1LjU4NjcyIDdMMC42MzY3MTkgMi4wNUwyLjA1MDcyIDAuNjM2MDAyTDcuMDAwNzIgNS41ODZaIiBmaWxsPSIjNzI3MjkyIi8+Cjwvc3ZnPgo=";